export default "https://cdn-static.gokick.com/assets/4beacdc4d8fafa1e61a7f98396d8ad8b9ab7b90c/images/tangerine-flavor.f6541269ddee78b301b9a4e8b180b6f6.png";